module.exports = __webpack_public_path__ + "img/erp-logos_0034_epicor.98826870.jpg";